<script lang="ts">
  import Input from '$shared/atoms/Input/Input.svelte';
  import createFieldValidator from '$shared/helpers/form-validator';
  import { npiValidator } from '$shared/helpers/form-validator/validators';

  interface Props {
    value?: string;
    label?: string;
    name?: string;
    required?: boolean;
    disabled?: boolean;
    placeholder?: string;
    readonly?: boolean;
    tabIndex?: number;
    onblur?: (e: FocusEvent) => void;
    onfocus?: (e: FocusEvent) => void;
    onchange?: (e: Event) => void;
    oninput?: (detail: { value: string }) => void;
  }

  let {
    value = '',
    label = 'NPI Number',
    name = 'npi',
    required = false,
    disabled = false,
    placeholder = '',
    readonly = false,
    tabIndex = 1,
    onblur,
    onfocus,
    onchange,
    oninput
  }: Props = $props();

  const [npiValidity, npiFieldValidator] = createFieldValidator([npiValidator(required)]);

  const onInput = (detail: { value: string }): void => {
    oninput?.(detail);
  };
</script>

<div class="comp-npi-input" use:npiFieldValidator={value}>
  <Input
    {label}
    {name}
    {value}
    {required}
    {disabled}
    {placeholder}
    {readonly}
    {tabIndex}
    error={$npiValidity.message || ''}
    oninput={onInput}
    {onblur}
    {onfocus}
    {onchange}
  />
</div>
